import { Injectable } from '@angular/core';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { Observable } from 'rxjs';
import { CloneTriggerComponent } from './clone-trigger.component';

@Injectable()
export class CloneTriggerService {
  constructor(private dialog: MatDialog) {}

  public open(initialVals: any): Observable<string> {
    let dialogRef: MatDialogRef<CloneTriggerComponent>;
    dialogRef = this.dialog.open(CloneTriggerComponent, {
      data: {
        model: initialVals
      }
    });

    return dialogRef.afterClosed();
  }
}
